import { Observable } from 'rxjs/Observable'

import { UserAnswerService } from '../../../data/services'
import { Question, TestExecution } from '../../../data/models'

const AUTOSAVE_WAIT_TIME_MS = 1000

export class TextQuestionAutosaver {

  public constructor(
    private _userAnswerService: UserAnswerService
  ) {}

  public autoSave(answerChanged: Observable<any>, question: Question, testExecution: TestExecution): Observable<any> {
    return answerChanged
      .debounce(() => Observable.timer(AUTOSAVE_WAIT_TIME_MS))
      .distinctUntilChanged()
      .concatMap((newText) => {
        return this._userAnswerService.findModelsBy({question: question}).concatMap((answers) => {
          const answer = answers[0] || this._userAnswerService.createModel({})
          answer.value = newText
          answer.question = question
          answer.testExecution = testExecution
          return this._userAnswerService.save(answer)
        })
      })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/text-question-autosaver/text-question-autosaver.ts